export default __webpack_public_path__ + "static/test_2_5-3b62ff624b058c581db95965d0182596.png";